import { ff } from '@atlassian/jira-feature-flagging';
import { FORGE_SAMPLING_RATE } from '../../../constants';
import { forgeModulesFetchTime } from '../performance-analytics';

export const measureExecutionTimeMetrics = async <T,>(
	key: string,
	action: () => Promise<T>,
): Promise<T> => {
	const shouldSendTimeMetric =
		!ff('fetch-forge-modules-sampling_1e415') || Math.random() * 100 < FORGE_SAMPLING_RATE;
	try {
		if (shouldSendTimeMetric) forgeModulesFetchTime.start({ startTime: performance.now() });
		const result = await action();
		if (shouldSendTimeMetric) forgeModulesFetchTime.stop({ stopTime: performance.now() });
		return result;
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		if (shouldSendTimeMetric) forgeModulesFetchTime.cancel();
		throw error;
	}
};
